import { createReducer, on } from '@ngrx/store';

import * as AvailableOffersActions from './available-offers.actions';
import { initialState, AvailableOffersState } from './available-offers.state';
import { AvailableOffersPersistenceService } from './available-offers-persistence.service';

const persistenceService = new AvailableOffersPersistenceService();

const loadFromStorage = (): AvailableOffersState => {
  const stored = persistenceService.loadFromLocalStorage();
  if (stored?.rawResponse) {
    return {
      ...initialState,
      rawResponse: stored.rawResponse,
      msisdnsByVariation: stored.msisdnsByVariation || {},
      lastUpdated: stored.lastUpdated || null
    };
  }
  return initialState;
};

const saveState = (state: AvailableOffersState): void => {
  if (state.rawResponse) {
    persistenceService.saveToLocalStorage(state);
  }
};

export const availableOffersReducer = createReducer(
  loadFromStorage(),

  on(AvailableOffersActions.loadAvailableOffers, state => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AvailableOffersActions.loadAvailableOffersSuccess, (state, { response }) => {
    const newState = {
      ...state,
      rawResponse: {
        avaliableMsisdnsForOffers: response.avaliableMsisdnsForOffers || {},
      },
      loading: false,
      error: null,
      lastUpdated: Date.now(),
    };
    saveState(newState);
    return newState;
  }),

  on(AvailableOffersActions.clearAvailableOffers, () => {
    persistenceService.clearFromLocalStorage();
    return initialState;
  }),

  on(AvailableOffersActions.mapOffersToVariations, (state, { offerToVariationMap }) => {
    const msisdnsByVariation: Record<string, string[]> = { ...state.msisdnsByVariation };

    if (!state.rawResponse || !state.rawResponse.avaliableMsisdnsForOffers) {
      console.warn('[AvailableOffers] rawResponse não disponível para mapeamento');
      return state;
    }

    const avaliableMsisdnsForOffers = state.rawResponse.avaliableMsisdnsForOffers;

    Object.entries(offerToVariationMap).forEach(([cpcOfferId, variationUuids]) => {
      // Valida se o cpcOfferId existe no response do AvailableOffers
      if (!(cpcOfferId in avaliableMsisdnsForOffers)) {
        console.warn(
          `[AvailableOffers] cpcOfferId "${cpcOfferId}" não encontrado em avaliableMsisdnsForOffers`,
          {
            availableOffers: Object.keys(avaliableMsisdnsForOffers),
            variationUuids
          }
        );
        // Não mapeia se o cpcOfferId não existir
        return;
      }

      // Busca os MSISDNs para esta oferta no response original
      const msisdnsForOffer = avaliableMsisdnsForOffers[cpcOfferId] || [];

      // Mapeia cada variationUuid para os MSISDNs da oferta
      variationUuids.forEach(variationUuid => {
        msisdnsByVariation[variationUuid] = msisdnsForOffer;
      });

      console.log(
        `[AvailableOffers] Mapeado cpcOfferId "${cpcOfferId}" para ${variationUuids.length} variation(s) com ${msisdnsForOffer.length} MSISDN(s)`
      );
    });

    const newState = {
      ...state,
      msisdnsByVariation,
      lastUpdated: Date.now(),
    };
    saveState(newState);
    return newState;
  }),

  on(AvailableOffersActions.loadAvailableOffersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    lastUpdated: Date.now(),
  }))
);

